/* surisa-cart.js — feedback de tope de stock en la vista de carrito.

   Cuando el usuario pulsa "+" en una línea cuya cantidad ya está en el stock
   máximo disponible (input[max]), el incremento nativo no hace nada y resulta
   confuso. Aquí mostramos un toast efímero junto al botón explicando el tope.

   Delegado en document (sobrevive a los re-render de cart.js) y bound una sola
   vez. El mensaje viene traducido desde Liquid en input[data-stock-msg]. */
(function () {
  if (window.SurisaCartToastBound) return;
  window.SurisaCartToastBound = true;

  var toastEl = null;
  var hideTimer = null;

  function ensureToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'surisa-cart-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    document.body.appendChild(toastEl);
    return toastEl;
  }

  function showToast(message, anchor) {
    if (!message) return;
    var t = ensureToast();
    t.textContent = message;
    var rect = anchor.getBoundingClientRect();
    t.style.top = window.scrollY + rect.top - 10 + 'px';
    t.style.left = window.scrollX + rect.left + rect.width / 2 + 'px';
    // forzar reflow para reiniciar la transición si ya estaba visible
    void t.offsetWidth;
    t.classList.add('is-visible');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      t.classList.remove('is-visible');
    }, 2600);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.surisa-cart .quantity__button[name="plus"]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input.quantity__input');
    if (!input || input.getAttribute('max') == null || input.getAttribute('max') === '') return;
    var max = parseInt(input.getAttribute('max'), 10);
    var val = parseInt(input.value, 10);
    if (!isNaN(max) && !isNaN(val) && val >= max) {
      showToast(input.getAttribute('data-stock-msg'), btn);
    }
  });
})();
